/**
 * @fileoverview Generic utility functions for CopilotBar scenarios.
 *
 * Contains shared helper functions that can be used across different
 * scenario types. Scenario-specific utilities should be placed in
 * their respective scenario folders.
 *
 * @module CopilotBar/scenarios/utils
 */

/**
 * Generates a unique chat ID string by joining non-empty identifiers.
 *
 * Creates a hyphen-separated string from the provided parameters,
 * filtering out any falsy values. Used to create unique identifiers
 * for Copilot chat sessions.
 *
 * @param {Object} params - Parameters object
 * @param {string} params.feature - The Copilot chat feature identifier (e.g., 'SAGE_COPILOT_CRUD')
 * @param {string} [params.name] - Optional entity name identifier
 * @param {string} [params.id] - Optional entity ID identifier
 * @param {string[]} [params.rest=[]] - Additional identifiers to append
 * @returns {string} A unique hyphen-separated chat ID string
 *
 * @example
 * getChatId({ feature: 'SAGE_COPILOT_CRUD', name: 'accounts', id: '123' });
 * // Returns: 'SAGE_COPILOT_CRUD-accounts-123'
 *
 * @example
 * getChatId({ feature: 'ANALYTICS', name: 'reports', id: '456', rest: ['monthly'] });
 * // Returns: 'ANALYTICS-reports-456-monthly'
 */
export const getChatId = ({ feature, id, name, rest = [] }) => {
    const parts = [feature, name, id, ...rest].filter(Boolean);
    return parts.join('-');
};
